import { padStart } from 'lodash'

/**
 * 补足数字位数
 * @param digit 数字
 * @param len 位数
 */
export const fillDigit = (digit: number, len: number) => {
  return padStart('' + digit, len, '0')
}

/**
 * 判断设备
 */
export const isPC = () => {
  return !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
}

/**
 * 将文件转成base64字符串
 */
export const getBase64ByBlob = (url: string) => {
  return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    if (!(url.indexOf('http') > -1 || url.indexOf('https') > -1)) {
      return resolve(url)    
    }
    let file: Blob
    const apiUrl = window.Glob.VUE_APP_HOST + '/api/Powerpoint/GetImageBase64Content'
    const params = {
      url    
    }
    // 将参数转换为查询字符串
    const queryString = new URLSearchParams(params).toString()
    // 拼接查询字符串到URL
    const fullUrl = `${apiUrl}?${queryString}`
    fetch(fullUrl, {
      headers: {
        Source: 'PPTCopilot',
      },
    })
      .then(response => response.json())
      .then((data) => {       
        if (data.code !== 200) {
          throw new Error('Network response was not ok ' + data.statusText)
        }       
        resolve(data.jsonValue)      
      })     
  })
}